export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} role="img" aria-label="Logo Rawan">
    <rect width="48" height="48" rx="14" fill="#3A2418" />
    <g fill="#F3E8D5">
      <ellipse cx="24" cy="12.5" rx="2.7" ry="5.2" />
      <ellipse cx="20.2" cy="18" rx="2.5" ry="4.8" transform="rotate(-26 20.2 18)" />
      <ellipse cx="27.8" cy="18" rx="2.5" ry="4.8" transform="rotate(26 27.8 18)" />
      <ellipse cx="20.2" cy="24.5" rx="2.5" ry="4.8" transform="rotate(-26 20.2 24.5)" />
      <ellipse cx="27.8" cy="24.5" rx="2.5" ry="4.8" transform="rotate(26 27.8 24.5)" />
    </g>
    <path d="M24 38 V14" stroke="#F3E8D5" strokeWidth="2.2" strokeLinecap="round" fill="none" />
  </svg>
);

export const Wordmark = ({ light = false }) => (
  <span className="flex flex-col leading-none">
    <span className={`font-serif text-xl tracking-wide ${light ? "text-crema" : "text-tinta"}`}>
      Rawan
    </span>
    <span
      className={`mt-1 text-[9px] font-semibold uppercase tracking-[0.28em] ${
        light ? "text-crema/60" : "text-tinta/55"
      }`}
    >
      Pastelería · Panadería
    </span>
  </span>
);

export default LogoMark;
